import React from 'react';
import { AiFillExclamationCircle } from 'react-icons/ai';
import { InputNoForm } from '~/components/Forms';
import WhiteBox from '~/components/WhiteBox';
import { BoxHeader } from '~/pages/Usuario/styles';
import { GridContainer, Wrap } from '~/styles/components';

export const ContatoSimplesResponsavel = ({
  boxTitle,
  boxInfo,
  responsaveis,
  setResponsaveis,
  editMode,
  bottomSize,
}) => {
  const handleChange = (event) => {
    const values = {...responsaveis};
    values[event.target.name] = event.target.value;
    setResponsaveis(values);
  };

  return (
    <>
      <WhiteBox column marginBottom="30px" bottom={bottomSize}>
        <BoxHeader style={{ justifyContent: 'space-between' }}>
          <span className="boxText">{boxTitle}</span>
          <div style={{ display: 'flex' }}>
            {boxInfo && (
              <span tooltip={boxInfo} style={{ marginRight: 5 }}>
                <AiFillExclamationCircle />
              </span>
            )}
          </div>
        </BoxHeader>

        <Wrap>
          <WhiteBox column style={{ bottom: '0' }}>
            <Wrap>
              <GridContainer cols={3}>
                <InputNoForm
                  type="text"
                  name="name"
                  label="Nome Civil/Nome Social"
                  required
                  value={responsaveis?.name}
                  onChange={handleChange}
                />
                <InputNoForm
                  type="text"
                  name="email"
                  label="E-mail"
                  value={responsaveis?.email}
                  required
                  onChange={handleChange}
                />
                <InputNoForm
                  type="text"
                  name="phone_mobile"
                  mask="(99) 99999-9999"
                  maskChar=""
                  label="Celular"
                  value={responsaveis?.phone_mobile}
                  required
                  onChange={handleChange}
                />
              </GridContainer>
            </Wrap>
          </WhiteBox>
        </Wrap>
      </WhiteBox>
    </>
  );
};
